import { Component, OnDestroy, Signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { stages } from '../../location-of-devices-unrelated-to-road.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ApplicationAppEntityApplicationRead, RoadOccupationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  LocationOfDevicesUnrelatedToRoadOccupationForm,
  occupationsToFormValue
} from './forms/location-of-devices-unrelated-to-road-occupation.form';
import {
  updateLocationOfDevicesUnrelatedToRoadOccupations
} from '../../../../../../store/actions/application.actions';
import {
  LocationOfDevicesUnrelatedToRoadOccupationFormComponent
} from './components/location-of-devices-unrelated-to-road-occupation-form/location-of-devices-unrelated-to-road-occupation-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ServiceListItem } from '../../../../../../services/service.common.model';
import { selectServiceByUrl } from '../../../../../../store/selectors/app.selectors';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    LocationOfDevicesUnrelatedToRoadOccupationFormComponent,
    ReactiveFormsModule
  ],
  providers: [LocationOfDevicesUnrelatedToRoadOccupationForm],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-data-section.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationDataSectionComponent implements OnDestroy {

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public stages = stages;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public serviceType: Signal<ServiceListItem | null> = this.store$.selectSignal(selectServiceByUrl(this.route?.parent?.snapshot?.data['contentUrl']));

  private fetchRoadOccupations: Subscription = toObservable(this.application).subscribe(app => {
    const occupations: Array<RoadOccupationAppEntityApplicationRead> = app?.roadOccupations || [];
    const occupation = occupationsToFormValue(occupations).at(0) || null;
    if (occupation) {
      this.form.patchFormValues(occupation);
    }
  });

  constructor(
    public form: LocationOfDevicesUnrelatedToRoadOccupationForm,
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store
  ) {
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateLocationOfDevicesUnrelatedToRoadOccupations({
        application: this.application(),
        occupations: [this.form.values],
        successFnc: (applicationId) => {
          this.router.navigate(
            ['../oplaty'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchRoadOccupations.unsubscribe();
  }

}
